import {all, fork, put,takeLatest, call, delay} from "redux-saga/effects"

import {
  EXPOSURE_PREVIEW,
  EXPOSURE_NEW,
  EXPOSURE_UPDATE,
  EXPOSURE_REMOVE,
  EXPOSURE_SEARCH
} from "constants/ActionTypes"

import {exposureDataSourceUpdate,exposureProcessSuccess,exposureProcessReset} from "appRedux/actions/setup/roomInformation/Exposure"
import {userSignOut} from "appRedux/actions/Auth"

import { APIGetRequest,APIPostRequest } from "util/connection"
import { API_URL_V1,API_PMS_HEADERS } from "constants/ApiSetting"
import { isUndefined,filter,orderBy } from "lodash"
import { IndexedDBAdd,IndexDBGetDataAll } from "util/indexedDBLibrary"
import { getItems } from "util/localStorage"

function* exposurePreviewProcess(){
    const  { access_token }  = yield call(getItems, ['access_token'])
    const AccessToken = access_token
    const url = `${API_URL_V1}pms/masterfile/roomExposure/`
    API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
    
    try {
      const response = yield APIGetRequest(url,API_PMS_HEADERS)

      if(response.status === 200)
      {
          const exposureDataSource = orderBy(response.data,[o => o.name.toLowerCase()],['asc']).map((obj, key) => {
          const container = {}
                container.key = key+1
                container.exposure_id = obj.id
                container.exposure_name = obj.name
          return container
          })
            
            /* if no error put everything to reducer */
             yield put(exposureDataSourceUpdate(exposureDataSource))
             yield IndexedDBAdd("ListBoxDB","objStoreExposureList",exposureDataSource)

      }else{
            /* Show error message and signout */
            const {message,data} = response.data
            const processStatus = { status: false, action: "preview", message}
            yield put(exposureProcessSuccess(processStatus))
            if(response.status === 403){
              /* if data is not null force signout */
              if(data)
                yield put(userSignOut())
            }
            
      }
      
    } catch (error) {
        const processStatus = { status: false, action: "preview", message:error}
        yield put(exposureProcessSuccess(processStatus))
    }
    
}

function* exposureSearchProcess({payload}){

  const storeValue = yield IndexDBGetDataAll('ListBoxDB', 'objStoreExposureList')
  const ReformalData = [...storeValue[0]]
  const keyword = payload.toLowerCase()

  if(!isUndefined(keyword)){
      /* Search by name */
      const filtered = filter(ReformalData, function(o) {
        return (o.exposure_name.toLowerCase().indexOf(keyword) > -1)
      })

      const mergeData = [...new Set([...filtered])]

      yield put(exposureDataSourceUpdate(mergeData))
  }else 
      yield put(exposureDataSourceUpdate(ReformalData))
}

function* exposureCreateProcess({payload}){
 
  const {exposure_name} = payload
  
  let exposureInfo = {}
      exposureInfo.name = exposure_name
      
      try {
            const  { access_token }  = yield call(getItems, ['access_token'])
            const AccessToken = access_token
            const url = `${API_URL_V1}pms/masterfile/roomExposure/create/`
            API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
            const API_DATABODY  = exposureInfo
            const response = yield APIPostRequest(url,API_DATABODY,API_PMS_HEADERS)

            if(response.status === 200){
              const processStatus = { status: true, action: "create", message:"Create success."}
              yield put(exposureProcessSuccess(processStatus))
              yield delay(100)
            }else{
              const {message,data} = response.data
              const processStatus = { status: false, action: "create", message}
              yield put(exposureProcessSuccess(processStatus))
              yield delay(100)
              yield put(exposureProcessReset())
              if(response.status === 403){
                /* if data is not null force signout */
                if(data)
                  yield put(userSignOut())
              } 
            }  

      } catch (error) {
            const processStatus = { status: false, action: "create", message:error}
            yield put(exposureProcessSuccess(processStatus))
            yield delay(100)
            yield put(exposureProcessReset())
      }

}

function* exposureUpdateProcess({payload}){

  const {exposure_id,exposure_name} = payload
  
  let exposureInfo = {}
      exposureInfo.id = exposure_id
      exposureInfo.name = exposure_name
      
      try {
            const  { access_token }  = yield call(getItems, ['access_token'])
            const AccessToken = access_token
            const url = `${API_URL_V1}pms/masterfile/roomExposure/update/`
            API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
            const API_DATABODY  = exposureInfo
            const response = yield APIPostRequest(url,API_DATABODY,API_PMS_HEADERS)

            if(response.status === 200){
              const processStatus = { status: true, action: "update", message:"Update success."}
              yield put(exposureProcessSuccess(processStatus))
              yield delay(100)
            }else{
              const {message,data} = response.data
              const processStatus = { status: false, action: "update", message}
              yield put(exposureProcessSuccess(processStatus))
              yield delay(100)
              yield put(exposureProcessReset())
              if(response.status === 403){
                /* if data is not null force signout */
                if(data)
                  yield put(userSignOut())
              } 
            }  

      } catch (error) {
            const processStatus = { status: false, action: "update", message:error}
            yield put(exposureProcessSuccess(processStatus))
            yield delay(100)
            yield put(exposureProcessReset())
      }
}

function* exposureRemoveProcess({payload}){
    const exposureRemove = payload
    

    try{
        const  { access_token }  = yield call(getItems, ['access_token'])
        const AccessToken = access_token
        const url = `${API_URL_V1}pms/masterfile/roomExposure/delete/`
        API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`
        const API_DATABODY = {id : exposureRemove}
        const response = yield APIPostRequest(url,API_DATABODY,API_PMS_HEADERS)
        if(response.status === 200){
          const processStatus = { status: true, action: "delete", message:"Delete success."}
          yield put(exposureProcessSuccess(processStatus))
          yield delay(100)
        }else{
          const {message,data} = response.data
          const processStatus = { status: false, action: "delete", message}
          yield put(exposureProcessSuccess(processStatus))
          yield delay(100)
          yield put(exposureProcessReset())
          if(response.status === 403){
            /* if data is not null force signout */
            if(data)
              yield put(userSignOut())
          }
        }  
    }
    catch(error){
      const processStatus = { status: false, action: "delete", message:error}
      yield put(exposureProcessSuccess(processStatus))
      yield delay(100)
      yield put(exposureProcessReset())
    }
}

/* Watcher Saga */
export function* exposurePreview() {
  yield takeLatest(EXPOSURE_PREVIEW, exposurePreviewProcess)
}
export function* exposureSearch(){
  yield takeLatest(EXPOSURE_SEARCH, exposureSearchProcess)
}
export function* exposureCreate(){
  yield takeLatest(EXPOSURE_NEW,exposureCreateProcess)
}
export function* exposureUpdate(){
  yield takeLatest(EXPOSURE_UPDATE, exposureUpdateProcess)
}
export function* exposureRemove(){
  yield takeLatest(EXPOSURE_REMOVE,exposureRemoveProcess)
}

export default function* rootSaga() {
  yield all([fork(exposurePreview),
             fork(exposureCreate),
             fork(exposureSearch),
             fork(exposureUpdate),
             fork(exposureRemove)])


}
